import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCategories } from "../../hooks/useCategories";

const CategorySelect = () => {
  const { categories, loading, error } = useCategories();
  const [path, setPath] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const navigate = useNavigate();

  const currentCategory = path.at(-1) || null;
  const subcategories = categories.filter((cat) =>
    currentCategory
      ? cat.parent_category_id === currentCategory.id
      : !cat.parent_category_id
  );
  const hasSubcategories = subcategories.length > 0;
  const canCreatePost = !hasSubcategories && currentCategory?.has_post;

  const handleBack = () => {
    setPath(path.slice(0, -1));
    setSelectedSubcategory(null);
  };

  const handleContinue = () => {
    if (hasSubcategories && selectedSubcategory) {
      const selected = subcategories.find(
        (cat) => cat.id === selectedSubcategory
      );
      if (selected) {
        setPath([...path, selected]);
        setSelectedSubcategory(null);
      }
    } else if (canCreatePost) {
      navigate(`/post/${currentCategory.id}`);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-sm">Loading...</div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-red-600 text-sm">Error loading categories.</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 font-sans text-lg">
      <div className="max-w-2xl mx-auto pt-8 px-4 pb-12">
        <div className="mb-8">
          {path.length > 0 && (
            <button
              onClick={handleBack}
              className="text-blue-600 hover:underline text-xs mb-4"
            >
              &lt; back
            </button>
          )}
          <h2 className="text-base font-normal mb-6">
            what type of posting is this:
          </h2>
          {hasSubcategories && (
            <div className="space-y-1 mb-6">
              {subcategories.map((cat) => (
                <label
                  key={cat.id}
                  className="flex items-center cursor-pointer hover:bg-gray-50 py-1"
                  onClick={() => {
                    setSelectedSubcategory(cat.id);
                    if (
                      categories.some((c) => c.parent_category_id === cat.id)
                    ) {
                      setPath([...path, cat]);
                      setSelectedSubcategory(null);
                    } else if (cat.has_post) {
                      navigate(`/post/${cat.id}`);
                    }
                  }}
                  style={{ userSelect: "none" }}
                >
                  <input
                    type="radio"
                    name="category"
                    value={cat.id}
                    checked={selectedSubcategory === cat.id}
                    onChange={() => setSelectedSubcategory(cat.id)}
                    className="mr-3"
                  />
                  <span className="text-sm">{cat.name.toLowerCase()}</span>
                </label>
              ))}
            </div>
          )}
          <button
            onClick={handleContinue}
            className={`bg-white border border-gray-400 px-4 py-1 text-sm hover:bg-gray-50 ${
              (hasSubcategories && !selectedSubcategory) ||
              (!hasSubcategories && !canCreatePost)
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            disabled={
              (hasSubcategories && !selectedSubcategory) ||
              (!hasSubcategories && !canCreatePost)
            }
          >
            continue
          </button>
          {!canCreatePost && !hasSubcategories && (
            <div className="text-xs text-gray-600 mt-4">
              no subcategories or post form available in this section.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategorySelect;
